import { type MutationHookOptions, useMutation } from "@apollo/client";
import { AttachStreamEntrypointMutation } from "../graphql/mutations";
import type {
  AttachStreamEntrypointMutationType,
  AttachStreamEntrypointMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useAttachStreamEntrypointMutation = (
  options?: MutationHookOptions<
    AttachStreamEntrypointMutationType,
    AttachStreamEntrypointMutationVariablesType
  >
) => {
  return useMutation<
    AttachStreamEntrypointMutationType,
    AttachStreamEntrypointMutationVariablesType
  >(AttachStreamEntrypointMutation, options);
};
